import React from 'react';
import classNames from 'classnames';
import CheckIcon from '../../../../design-system/icons/core/check.svg?component';
import { RCCheckableLabel, CheckableLabelProps } from './RCCheckableLabel';
import { RCSwitch } from './RCSwitch';
import { RCIcon } from '../../RCIcon';

interface IRCCheckbox extends CheckableLabelProps {
  name: string;
  id: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  checked: boolean;
  required?: boolean;
  /** What widget to display for this input. Typically a switch should persist changes immediately when changed. */
  variant?: 'checkbox' | 'switch';
  disabled?: boolean;
  errorText?: string;
}

export function RCCheckbox({ variant = 'checkbox', ...props }: IRCCheckbox) {
  if (variant === 'switch') {
    return <RCSwitch {...props} />;
  }

  return (
    <span className={classNames(
      'rc-checkbox',
      { 'rc-checkbox--disabled': props.disabled },
    )}>
      <input
        className="rc-checkbox__input"
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
        required={props.required}
      />
      <span className="rc-checkbox__box">
        <RCIcon svgComponent={CheckIcon} />
      </span>
      <RCCheckableLabel
        for={props.id}
        sublabel={props.sublabel}
        label={props.label}
        errorText={props.errorText}
      />
    </span>
  );
}
